
import { combineReducers } from "redux";
import {
  alerts,
  alertsForm,
  app,
  appointments,
  appointmentsForm,
  authorization,
  bulkAppointmentsForm,
  currentRoute,
  currentScheduleParams,
  currentTheme,
  equipments,
  equipmentsForm,
  groups,
  groupsForm,
  incidents,
  incidentsForm,
  locations,
  locationsForm,
  monthlySchedule,
  notifications,
  permissions,
  permissionsForm,
  profile,
  roles,
  rolesForm,
  shifttypes,
  shifttypesForm,
  userFilter,
  users,
  usersForm,
  workorders,
  workordersForm,
  holidays,
  holidaysForm,
  attendancerecords,
  attendancerecordsForm,
  timechangerequests,
  timechangerequestsForm,
  irregularitytypes,
  irregularitytypesForm,
  irregularitys,
  irregularitysForm,
  maintenances,
  maintenancesForm,
} from "./Reducers";

export default combineReducers({
  maintenances,
  maintenancesForm,
  irregularitys,
  irregularitysForm,
  irregularitytypes,
  irregularitytypesForm,
  timechangerequests,
  timechangerequestsForm,
  attendancerecords,
  attendancerecordsForm,
  holidays,
  holidaysForm,
  permissions,
  permissionsForm,
  groups,
  groupsForm,
  appointments,
  appointmentsForm,
  bulkAppointmentsForm,
  monthlySchedule,
  currentScheduleParams,
  userFilter,
  shifttypes,
  shifttypesForm,
  workorders,
  workordersForm,
  incidents,
  incidentsForm,
  roles,
  rolesForm,
  locations,
  locationsForm,
  equipments,
  equipmentsForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
});
